import {
  Button,
  Card,
  Icons,
  Loader,
  Text,
} from "@pushpress/shared-components";
import { Container, Row } from "reactstrap";
import OnboardingTaskListCard from "./OnboardingTaskListCard";
import styles from "./SetupGuide.module.scss";
import { useOnboardingTaskListsQuery } from "../../../../apis/taskApi.hooks";
import { useAnalytics } from "../../../../components/providers/AnalyticsProvider";
import { GetStartedEvent } from "../../events";

function SetupGuide() {
  const { data, isLoading, isError, refetch, error } =
    useOnboardingTaskListsQuery();
  const { trackEvent } = useAnalytics();

  const setupGuideHeader = (
    <>
      <Text style={{ marginBottom: 20 }} variant="heading-3">
        Setup guide
      </Text>
      <Text style={{ marginBottom: 20 }} variant="body-lg">
        Kickstart your journey with these essential steps to get up and running
        quickly.
      </Text>
    </>
  );

  if (isLoading) {
    return (
      <Container>
        <Card className="p-4">
          <Row className={styles.loadingCard}>
            <Loader />
          </Row>
        </Card>
      </Container>
    );
  }

  if (!isLoading && isError) {
    trackEvent(GetStartedEvent.TaskListLoadFailed, {
      // @ts-ignore
      error: error.message ?? error,
      task_list_type: "onboarding",
    });
    return (
      <Container>
        {setupGuideHeader}
        <Card className="p-4">
          <Row className={styles.loadingCard}>
            <Icons.Alert
              style={{ height: "30px", width: "30px", color: "red" }}
            />
            <Text variant="body-lg">
              Oops! We couldn&apos;t load your onboarding checklist.
            </Text>
            <Text color="wolf-600">
              This could be due to a network issue or a temporary problem on our
              end.
            </Text>
            <Button size="small" text="Retry" onClick={() => refetch()} />
          </Row>
        </Card>
      </Container>
    );
  }

  if (!isLoading && data && data.length === 0) {
    trackEvent(GetStartedEvent.TaskListLoadFailed, {
      error: "not_found",
      task_list_type: "onboarding",
    });
  }

  return (
    <Container>
      {data?.length > 0 && (
        <>
          {setupGuideHeader}
          {data.map((taskList) => (
            <Row className={styles.setupCard} key={taskList.taskListId}>
              <OnboardingTaskListCard taskList={taskList} />
            </Row>
          ))}
        </>
      )}
    </Container>
  );
}

export default SetupGuide;
